import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad skiljer gårdsförsäljning från Systembolaget?";
const SHORT_ANSWER = "Systembolaget har detaljhandelsmonopol och säljer alla godkända produkter rikstäckande. Gårdsförsäljning är fysisk småförsäljning från producenten direkt, med strikta volymbegränsningar.";

export const Route = createFileRoute("/fraga/vad-ar-skillnaden-mot-systembolaget")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad skiljer gårdsförsäljning från Systembolaget" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Gårdsförsäljning är ett komplement, inte ersättning. Systembolagets distributionsroll kvarstår för all annan detaljhandelsförsäljning av alkohol."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning", label: "Gårdsförsäljning – komplett hubb" }}
      related={[{"to": "/fraga/vad-ar-serveringstillstand", "label": "Vad är ett serveringstillstånd?"}, {"to": "/fraga/vem-behover-serveringstillstand", "label": "Vem behöver söka serveringstillstånd?"}, {"to": "/fraga/nar-trader-gardsforsaljning-i-kraft", "label": "När träder gårdsförsäljningen i kraft?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad skiljer gårdsförsäljning från Systembolaget?" },
      { name: "description", content: "Systembolaget har detaljhandelsmonopol och säljer alla godkända produkter rikstäckande. Gårdsförsäljning är fysisk småförsäljning från producenten direkt, me…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-skillnaden-mot-systembolaget" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-skillnaden-mot-systembolaget" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-skillnaden-mot-systembolaget",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad skiljer gårdsförsäljning från Systembolaget", url: "https://alkoholprovet.se/fraga/vad-ar-skillnaden-mot-systembolaget" },
      ]),
    ],
  }),
});
